import { TruckUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/transportation/v1/truck_events_pb';
import { Col, DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

import { truckStatusLabels } from '../enumLabels';

type TruckUpdatedDetailProps = {
  event: TruckUpdatedEvent;
};

export const TruckUpdatedDetail = ({ event }: TruckUpdatedDetailProps) => {
  const previous = event.previousTruck;
  const current = event.updatedTruck;

  if (!previous || !current) {
    return (
      <Col className="@TruckUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'licensePlate',
      label: 'License Plate',
      previous: previous.licensePlate,
      current: current.licensePlate,
    },
    {
      field: 'status',
      label: 'Status',
      previous: truckStatusLabels[previous.status],
      current: truckStatusLabels[current.status],
    },
    {
      field: 'vin',
      label: 'VIN',
      previous: previous.vin,
      current: current.vin,
    },
    {
      field: 'model',
      label: 'Model',
      previous: previous.model,
      current: current.model,
    },
    {
      field: 'capacity',
      label: 'Capacity',
      previous: previous.capacity ? String(previous.capacity) : '',
      current: current.capacity ? String(current.capacity) : '',
    },
    {
      field: 'country',
      label: 'Country',
      previous: previous.country,
      current: current.country,
    },
    {
      field: 'state',
      label: 'State',
      previous: previous.state,
      current: current.state,
    },
  ];

  return (
    <Col className="@TruckUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">Truck</span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="License Plate" value={current.licensePlate} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
